import { AgentKnowledgeStatus } from "@redotech/cockroachdb-codegen/tables/agent-knowledge/agent-knowledge-status";
import {
  productKnowledgeDraftSchema,
  productKnowledgeEntrySchema,
} from "@redotech/shopper-agent-knowledge-common/product-knowledge-view";
import * as z from "zod";

export const createProductKnowledge = {
  name: "createProductKnowledge" as const,
  input: z.object({
    draft: productKnowledgeDraftSchema,
    /** Omitted means DRAFT, so nothing goes live by accident. */
    status: z.enum(AgentKnowledgeStatus).optional(),
  }),
  output: productKnowledgeEntrySchema,
};
